import React from 'react';

export const LogoExternal = ({ maxHeight = "56px", imgSrc, imgAlt, externalLink }) => {
  return (
    <div>
      {/* {showText && <p className="ek-labeltext-12-medium pb-14">Ein Service der</p>} */}
      <a href={externalLink} target="_blank" rel="noopener noreferrer" className='d-inline-block'>
        <img src={imgSrc} style={{ maxWidth: '100%', maxHeight: maxHeight }} alt={imgAlt} />
      </a>
    </div>
  );
};

export default LogoExternal;
